export default class InputQuantity extends HTMLElement {
    constructor(m) {
        super(m);

        // Binding
        this.decrement = this.decrement.bind(this);
        this.increment = this.increment.bind(this);
        this.updateButtons = this.updateButtons.bind(this);

        // UI
        this.$input = this.querySelector('input');
        this.$decrement = this.querySelector('[data-decrement]');
        this.$increment = this.querySelector('[data-increment]');

        // Data
        this.min = this.$input.getAttribute('min') || null;
        this.max = this.$input.getAttribute('max') || null;
        this.step = this.$input.getAttribute('step') || 1;
        this.value = this.$input.getAttribute('value') || 0;

        // Set initial value
        this.$input.value = this.value;

        // Disable buttons if min/max reached
        this.updateButtons();
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.$decrement.addEventListener('click', this.decrement);
        this.$increment.addEventListener('click', this.increment);
        this.$input.addEventListener('change', this.updateButtons);
    }

    unbindEvents() {
        this.$decrement.removeEventListener('click', this.decrement);
        this.$increment.removeEventListener('click', this.increment);
        this.$input.removeEventListener('change', this.updateButtons);
    }

    // =============================================================================
    // Methods
    // =============================================================================
    decrement() {
        this.$input.value = Math.max(this.min, this.$input.value - this.step);
        this.updateButtons();
        this.$input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    increment() {
        this.$input.value = Math.min(this.max, parseInt(this.$input.value) + parseInt(this.step));
        this.updateButtons();
        this.$input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateButtons() {
        if (this.min !== null && this.$input.value <= this.min) {
            this.$decrement.setAttribute('disabled', '');
        } else {
            this.$decrement.removeAttribute('disabled');
        }

        if (this.max !== null && this.$input.value >= this.max) {
            this.$increment.setAttribute('disabled', '');
        } else {
            this.$increment.removeAttribute('disabled');
        }
    }
}
